import { createTheme } from "@mui/material";

const sharedShape = {
    borderRadius: 10,
}

const sharedButton = {
    styleOverrides: {
        root: {
            boxShadow: "none",
            textTransform: "none",
            fontWeight: 700,
            "&:hover": {
                boxShadow: "none",
            },
        },
    },
}

const Light = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#000435",
        },
        secondary: {
            main: "#00A3FF",
        },
        background: {
            default: "#ffffff",
            paper: "#ffffff",
        },
        text: {
            primary: "#000435",
            secondary: "rgba(0, 4, 53, 0.68)",
        },
    },
    typography: {
        fontFamily: '"DM Sans", "Segoe UI", Helvetica, Arial, sans-serif',
        h2: { fontWeight: 800 },
        h4: { fontWeight: 800 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        button: { fontWeight: 700 },
    },
    shape: sharedShape,
    zIndex: {
        drawer: 1100,
        appBar: 1200,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,400&display=swap');
                body {
                    background-color: #ffffff;
                }
            `,
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: "transparent",
                    boxShadow: "none",
                },
            },
        },
        MuiButton: sharedButton,
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                },
            },
        },
    },
})

const Dark = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#000435",
        },
        secondary: {
            main: "#00A3FF",
        },
    },
    typography: {
        fontFamily: '"DM Sans", "Segoe UI", Helvetica, Arial, sans-serif',
    },
    shape: sharedShape,
    zIndex: {
        drawer: 1100,
        appBar: 1200,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: "transparent",
                    boxShadow: "none",
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    background: "#000435",
                },
            },
        },
        MuiButton: sharedButton,
    },
})

export default {
    Light,
    Dark,
}
